module.exports = __webpack_public_path__ + "static/img/slider-3.3906b76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider/slider-3.jpg
// module id = a0qs
// module chunks = 0